<template>
  <b-container fluid class="contendordepagina">
    <div class="mx-4">
      <loading :active.sync="isLoading" :is-full-page="isFullPage"></loading>
      <b-row class="mb-3">
        <b-col cols="5">
          <b-form-group description="" label="Texto">
            <b-form-input v-model="buscatexto" @keyup.enter="cargarItems"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group description="" label="Estado de la firma">
            <b-form-select v-model="estado" :options="optEstados" @change="cargarItems" class="mr-1"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group description="" label="Tipologia">
            <b-form-select class="mr-1" v-model="tipologia" :options="optTipologias" value-field="codigo" text-field="descripcion" @change="cargarItems"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label="">
            <br />
            <b-form-checkbox id="solomisenvios" name="solomisenvios" v-model="solomisenvios" switch>Ver solo enviados por mi</b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="1">
          <br />
          <b-button @click="cargarItems" class="mr-1 bgcolor-manusa">
            <b-icon-arrow-repeat></b-icon-arrow-repeat>
          </b-button>
        </b-col>
      </b-row>

      <div v-show="estado" class="h3">{{ tituloestado }}</div>
      <div v-if="!primerabusquedalanzada">Indica los criterios de filtrado y pulsa sobre el botón <b-icon-arrow-repeat></b-icon-arrow-repeat> para iniciar la búsqueda</div>
      <div v-else-if="primerabusquedalanzada && items && items.length === 0" class="alert alert-info">No se ha encontrado ningún envío con los criterios indicados</div>
      <div v-else-if="primerabusquedalanzada && items && items.length">
        <b-pagination v-model="paginaActual" :total-rows="numItems" :per-page="20" aria-controls="my-table"></b-pagination>
        <p class="mt-3">{{ numItems }} envíos encontrado(s)</p>
        <b-table striped hover id="my-table" :current-page="paginaActual" :per-page="20" :busy.sync="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="items" :fields="fields" :tbody-tr-class="rowClass">
          <template v-slot:cell(documento)="data">
            <strong>{{ data.item.titulo }}</strong
            ><br />
            <span class="text-gray">{{ data.item.fichero }}</span
            ><br />
            <small>ID: {{ data.item.id }}</small
            ><br />
          </template>
          <template v-slot:cell(firmantes)="data">
            <ul class="m-0 p-0" style="list-style: none">
              <li v-for="d in data.item.docs" :key="d.id" :title="d.name + ', ' + d.email">{{ d.name }} - <span v-html="estadofirma(d.status)"></span></li>
            </ul>
          </template>
          <template v-slot:cell(actions)="row">
            <!-- <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                          Actualizar
                      </b-button> -->
            <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-1 bgcolor-manusa">
                          {{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }} Detalles
                      </b-button> -->
            <div class="text-center">
              <b-button v-if="row.item.status == 'COMPLETADO'" v-b-modal.modal-1 @click="descargarDocumento(row.item.titulo, 'firmado', row.item.id, row.item.docs[0].id)" class="m-1 bgcolor-manusa"><b-icon-file-arrow-down></b-icon-file-arrow-down> Firmado</b-button>
              <b-button v-if="row.item.status == 'COMPLETADO'" v-b-modal.modal-1 @click="descargarDocumento(row.item.titulo, 'evidencias', row.item.id, row.item.docs[0].id)" class="m-1 bgcolor-manusa"><b-icon-file-arrow-down></b-icon-file-arrow-down> Evidencias</b-button>
              <span v-if="row.item.status == 'CANCELADO'" class="alert alert-danger">Cancelado</span>
              <span v-if="row.item.status == 'DECLINADO'" class="alert alert-warning">Declinado por alguno de los firmantes</span>
              <span v-if="row.item.status == 'PENDIENTE'" class="alert alert-info">Pendiente de firma</span>
              <b-button v-b-modal.modal-1 @click="descargarDocumento(row.item.titulo, 'original', row.item.id, row.item.docs[0].id)" class="m-1 bgcolor-manusa"><b-icon-file-arrow-down></b-icon-file-arrow-down> Original</b-button>
            </div>
          </template>
          <template v-slot:row-details="row">
            <b-card>
              <!-- <ul>
                              <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                          </ul> -->
              <ul>
                <li v-for="(d, index) in row.item.docs" :key="index">
                  <ul>
                    <li v-for="(value, key) in d" :key="key">{{ key }}: {{ value }}</li>
                  </ul>
                </li>
              </ul>
              <b-button v-if="row.item.status == 'COMPLETADO'" v-b-modal.modal-1 @click="descargarDocumento(row.item.titulo, 'firmado', row.item.id, row.item.docs[0].id)">Abrir documento</b-button>
            </b-card>
          </template>
        </b-table>
      </div>

      <!-- <div v-if="titulopdf.length">
              <b-button v-b-modal.modal-1>Ampliar</b-button>
              <b-modal id="modal-1" :title="titulopdf">
                  <AbrirPDF :src="srcpdf"></AbrirPDF>
              </b-modal>
          </div> -->
    </div>
    <div>
      <!-- <b-button v-b-modal.modal-1>Ampliar</b-button> -->
      <b-modal size="xl" id="modal-1" :title="titulopdf" hide-footer>
        <AbrirPDF v-if="titulopdf.length" :titulo="titulopdf" :src="srcpdf"></AbrirPDF>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
import AbrirPDF from '@/components/AbrirPDF.vue';
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'ListadoDocs',
  components: {
    AbrirPDF,
    Loading
  },
  computed: {
    numItems() {
      return this.items ? this.items.length : 0;
    },
    tituloestado() {
      if (!this.estado) return '';
      return this.optEstados.filter((e) => e.value === this.estado)[0].text;
    },
    ...mapState(['user']),
    usuario_nombre: {
      get() {
        if (!this.user) return '';
        console.log('get', this.user);
        return this.user.nombre;
      }
    },
    usuario_token: {
      get() {
        if (!this.user) return '';
        return this.user.token;
      }
    },
    usuario_email: {
      get() {
        if (!this.user) return '';
        return this.user.email;
      }
    }
  },
  data() {
    return {
      primerabusquedalanzada: false,
      isBusy: false,
      sortBy: 'fecha',
      sortDesc: true,
      titulopdf: '',
      srcpdf: '',
      fields: [
        { key: 'documento', label: 'Documento' },
        //{ key: 'titulo', label: 'Documento', sortable: true, class: 'text-left' },
        //{ key: 'status', label: 'Estado', sortable: true, class: 'text-center' },
        //{ key: 'id', label: 'ID', sortable: true, class: 'text-center' },
        { key: 'firmantes', label: 'Firmantes' },
        {
          key: 'created_at',
          label: 'Fecha',
          sortable: true,
          class: 'text-center',
          formatter: (value) => {
            return this.$moment(value).format('LLLL');
          }
        },
        {
          key: 'enviadopor',
          label: 'Enviado por',
          sortable: true,
          class: 'text-center',
          formatter: (value) => {
            return value.nombre;
          }
        },
        {
          key: 'tipologia',
          label: 'Tipo',
          sortable: true,
          class: 'text-center',
          formatter: (value) => {
            return value.descripcion;
          }
        },
        { key: 'actions', label: 'Accciones' }
      ],
      items: [],
      optEstados: [
        { value: 'null', text: 'Selecciona una opción' },
        { value: 'ready', text: 'Pendientes de firma' },
        { value: 'completed', text: 'Firma completada' },
        { value: 'declined', text: 'Firma declinada por algún firmante' },
        { value: 'canceled', text: 'Firma cancelada' }
      ],
      estado: null,
      isLoading: false,
      isFullPage: true,
      optTipologias: [{ codigo: null, descripcion: 'Selecciona un tipo' }],
      tipologia: null,
      solomisenvios: true,
      paginaActual: 1,
      signaturitInPage: 10,
      signaturitVersion: '',
      buscatexto: ''
    };
  },
  mounted() {
    var _t = this;
    setTimeout(() => {
      // Se preparan las opciones de Tipologias para el select
      _t.$store.getters.misTipologiasDeBusqueda.forEach((t) => {
        _t.optTipologias.push(t);
      });
      if (_t.$store.getters.miModoApp !== 'SIGNATURITDEV') {
        _t.signaturitVersion = '1.0.0';
      } else {
        _t.signaturitVersion = '0.9.0';
      }
      //_t.cargarItems(null)
    }, 1000);
  },
  methods: {
    estadofirma(codigo) {
      let estado = codigo;
      switch (codigo) {
        case 'ready':
          estado = '<span class="text-info">Pendiente <b-icon-clock-history></b-icon-clock-history></span>';
          break;
        case 'completed':
          estado = '<span class="text-success">Firmado <b-icon-check-circle></b-icon-check-circle></span>';
          break;
        case 'declined':
          estado = '<span class="text-danger">Declinado <b-icon-exclamation-circle></b-icon-exclamation-circle></span>';
          break;
        case 'canceled':
          estado = '<span class="text-danger">Cancelado <b-icon-exclamation-circle></b-icon-exclamation-circle></span>';
          break;
        case 'expired':
          estado = '<span class="text-danger">Expirado <b-icon-exclamation-circle></b-icon-exclamation-circle></span>';
          break;
      }
      return estado;
    },
    descargarDocumento(titulo, tipo, id1, id2) {
      let url = 'get-base64-documento-' + tipo + '/' + this.$store.getters.miModoApp + '/' + id1 + '/' + id2;
      console.log(url);
      var _t = this;
      _t.titulopdf = '';
      _t.srcpdf = '';
      //this.axios.defaults.baseURL = process.env.VUE_APP_API_URL
      this.axios
        .post(
          '/efirma/accion',
          { accion: url, method: 'GET', resptype: 'text' },
          {
            headers: {
              Authorization: `Bearer xuhnrfrQOGsJZAGwSFwpNAAOvYUHnmEixEHMVYADxVjMfOZTsATgqeqDJTsSbJJULMbwESdEyOWQhNnOZLoasL`
            }
          }
        )
        .then(function (response) {
          _t.titulopdf = tipo + '-' + titulo;
          _t.srcpdf = 'data:application/pdf;base64,' + response.data;
          console.log('Respuesta API', _t.srcpdf.length);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async cargarItemsRec(ctx2) {
      ctx2.page++;
      try {
        console.log(ctx2);
        const response = await this.axios.post('/efirma/accion', ctx2, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.usuario_token}`
          }
        });
        if (response.data.resp && response.data.resp.length) {
          this.items = this.items.concat(response.data.resp);
          if (response.data.resp.length === this.signaturitInPage) this.cargarItemsRec(ctx2);
        }
      } catch (error) {
        console.log('error cargaritemsrec ' + error);
      }
    },
    async cargarItems() {
      this.primerabusquedalanzada = true;
      let tipologias = [];
      if (this.tipologia) tipologias = [this.tipologia];
      else {
        this.optTipologias.forEach((t) => {
          if (t.codigo) tipologias.push(t.codigo);
        });
      }
      let ctx2 = {
        modoapp: this.$store.getters.miModoApp,
        version: this.signaturitVersion,
        page: 1,
        inpage: this.signaturitInPage,
        tipologias: tipologias,
        solomisenvios: this.solomisenvios ? this.$store.getters.miEmail : null,
        estado: this.estado,
        buscatexto: this.buscatexto,
        accion: 'obtener-efirmas'
        //departamento: this.departamento
      };
      // if (this.solomisenvios) ctx2["email"] = this.usuario_email
      // if (this.status) ctx2["status"] = this.status
      // if (this.tipologia) ctx2["tipologia"] = this.tipologia
      this.items = [];
      this.isBusy = true;
      this.isLoading = true;
      try {
        console.log(ctx2);
        const response = await this.axios.post('/efirma/accion', ctx2, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.usuario_token}`
          }
        });
        this.isBusy = false;
        this.items = response.data.resp;
        this.isLoading = false;
        if (response.data.resp && response.data.resp.length === this.signaturitInPage) this.cargarItemsRec(ctx2);
      } catch (error) {
        this.isBusy = false;
        this.isLoading = false;
        console.log('error cargaritemsrec ' + error);
      }
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return;
      if (item.status === 'firmado') return 'table-success';
    }
  },
  watch: {
    solomisenvios() {
      this.cargarItems();
    }
  }
};
</script>
<style scoped>
h1 {
  font-size: 1.5em;
  color: var(--color-manusa-azul);
}
h2 {
  font-size: 1.4em;
  background-color: #c4de45;
  padding: 0.2em 1em;
  color: black;
  border-radius: 1em;
}
h3 {
  font-size: 1.3em;
  color: #eb3d77;
}
.badge-info {
  background-color: #4256f9 !important;
  color: white;
}
.btn-outline-secondary:hover {
  color: #fff !important;
  background-color: #1d6db5 !important;
  border-color: #1d6db5 !important;
}
.text-gray {
  color: gray;
}
</style>
